<span class="container" *ngIf="shouldDisplayValue()">
  <b>$</b>
  <span>{{ +params.value | number: '1.2-2' }}</span>
</span>
